var NAMESPACE = 'td';

var Progress = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-progress", class: ['td-progress--' + _vm.type], style: _vm.circleSize }, [_vm.type === 'circle' ? _c('div', { staticClass: "td-progress-circle" }, [_c('svg', { staticClass: "td-progress-circle__track", attrs: { "viewBox": _vm.view } }, [_c('circle', { staticClass: "td-progress-circle__track", style: { stroke: _vm.outerColor }, attrs: { "cx": _vm.circleDistance, "cy": _vm.circleDistance, "r": _vm.radius, "stroke-width": _vm.strokeWidth } }), _vm._v(" "), _c('circle', { staticClass: "td-progress-circle__path", style: _vm.circlePathStyle, attrs: { "cx": _vm.circleDistance, "cy": _vm.circleDistance, "r": _vm.radius, "stroke-width": _vm.strokeWidth, "stroke-linecap": _vm.linecap } })])]) : _c('div', { staticClass: "td-progress-bar", style: { height: _vm.height + 'px' } }, [_c('div', { staticClass: "td-progress-bar__outer", style: { backgroundColor: _vm.outerColor } }, [_c('div', { staticClass: "td-progress-bar__inner", style: { width: _vm.value + '%', backgroundColor: _vm.color } })])]), _vm._v(" "), _c('p', { directives: [{ name: "show", rawName: "v-show", value: _vm.textVisible, expression: "textVisible" }], staticClass: "td-progress__text" }, [_vm._t("default", [_vm._v(_vm._s(_vm.value) + "%")])], 2)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-progress',

  props: {
    type: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return ['line', 'circle'].includes(val);
      }
    },
    color: String,
    height: Number,
    outerColor: String,
    textVisible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: Number,
      default: 120
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    linecap: {
      type: String,
      default: 'round'
    }
  },
  computed: {
    circleSize: function circleSize() {
      // 圆环大小
      return this.type === 'circle' ? { width: this.width + 'px', height: this.height + 'px' } : {};
    },
    radius: function radius() {
      // 半径
      if (this.type === 'circle') {
        return this.width / 2 - this.strokeWidth;
      }
      return 0;
    },
    circleDistance: function circleDistance() {
      // 圆环的位置
      var distance = this.radius + this.strokeWidth;
      return distance;
    },
    perimeter: function perimeter() {
      // 圆环周长
      return 2 * Math.PI * this.radius;
    },
    view: function view() {
      // 视图大小
      var view = '0 0 ' + this.width + ' ' + this.width;
      return view;
    },
    circlePathStyle: function circlePathStyle() {
      // 绘制圆环
      var color = this.color;
      if (this.value === 0) {
        color = 'transparent';
      }
      return {
        strokeDasharray: this.perimeter * (this.value / 100) + 'px, ' + this.perimeter + 'px',
        transform: 'rotate(-90deg)',
        stroke: color,
        transformOrigin: this.circleDistance + 'px ' + this.circleDistance + 'px',
        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
      };
    }
  }
};

Progress.install = function (Vue) {
  Vue.component(Progress.name, Progress);
};

export default Progress;
